import { COLOR_TAGS_SEARCH_SCROLL_LOCALSTORAGE } from '../types';

export const getColorTagsSearchScrollLocalStorage = (): boolean => {
    return !localStorage.getItem(COLOR_TAGS_SEARCH_SCROLL_LOCALSTORAGE);
}
